import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/lib/api/rawFetch'
import { DASHBOARD_POLL_MS, isWarmingError } from '@/hooks/useDashboard'
import type { ProductTypeDemandRow } from '@/lib/api/session11Types'

export function useProductTypeDemand() {
  return useQuery({
    queryKey: ['product-type-demand'] as const,
    queryFn: () => apiFetch<ProductTypeDemandRow[]>('GET', '/api/inventory/product-type-demand'),
    staleTime: 30_000,
    // Derived from the dashboard build: retry on its own while it's warming.
    refetchInterval: (q) => (isWarmingError(q.state.error) ? DASHBOARD_POLL_MS : false),
  })
}
